import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useState } from "react";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CommonSelectWithoutNoneOption({ data, onChange, label, defaultValue }) {
  const [company, setCompany] = useState(defaultValue);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setCompany(selectedValue);
    onChange(selectedValue);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 300, width: "100%" }}>
        <InputLabel
          style={{ marginLeft: "-8px", marginTop: "-7px", backgroundColor: "white" }}
          id="demo-simple-select-autowidth-label"
        >
          {label}
        </InputLabel>
        <Select
          style={{ minHeight: "45px", marginLeft: "-8px", marginTop: "-7px" }}
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={company}
          onChange={handleChange}
          label={label}
          inputProps={{
            IconComponent: () => (
              <ExpandMoreIcon
                style={{
                  marginRight: "5px",
                  pointerEvents: "none",
                  position: "absolute",
                  right: "10px",
                }}
              />
            ),
          }}
        >
          {data.map((elem) => (
            <MenuItem key={elem.id} value={elem.id}>
              {elem.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
CommonSelectWithoutNoneOption.defaultProps = {
  data: [],
  label: "Empresas",
  defaultValue: "",
};

CommonSelectWithoutNoneOption.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
};
